import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ContactUsModal } from '../../sideMenu/contactUs/ContactUsModal';

import alertIcon from '../../../assets/petDemos/alert-error-red.svg';

import styles from './SubmitFailure.module.css';

const SubmitFailure = ({ onGoBackAndRetryPress = () => { } }) => {
  const { t } = useTranslation('petDemos');
  const [showModal, setShowModal] = useState(false);

  const onContactSupportPress = () => {
    setShowModal(true);
  };

  const onCloseContactUsModal = () => {
    setShowModal(false);
  };

  return (
    <div className={styles.mainContainer}>
      <img alt="Alert Icon" src={alertIcon} />

      <h1>{t('submitFailure.title')}</h1>

      <p>{t('submitFailure.description')}</p>

      <div className={styles.buttonsContainer}>
        <button
          className={styles.goBackButton}
          onClick={onGoBackAndRetryPress}
          type="button"
        >
          {t('submitFailure.goBackAndRetryButton')}
        </button>

        <button
          className={styles.contactSupportButton}
          onClick={onContactSupportPress}
          type="button"
        >
          {t('submitFailure.contactSupportButton')}
        </button>
      </div>

      <ContactUsModal
        onClose={onCloseContactUsModal}
        show={showModal}
      />
    </div>
  );
};

export { SubmitFailure };
